import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const ConfirmDeleteModal = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Conferma Eliminazione</DialogTitle>
      <DialogContent>
        <Typography>Sei sicuro di voler eliminare questo elemento?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Annulla
        </Button>
        <Button onClick={onConfirm} color="error">
          Elimina
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
